module.exports = __webpack_public_path__ + "static/media/Kebab.0244dda2.svg";